import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Grid.svg",
  "use": "Grid.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Grid.svg\"><path d=\"M47.01,50.0209h-10a3,3,0,0,1-3-3v-10a3,3,0,0,1,3-3h10a3,3,0,0,1,3,3v10A3,3,0,0,1,47.01,50.0209Zm0-20h-10a3,3,0,0,1-3-3v-10a3,3,0,0,1,3-3h10a3,3,0,0,1,3,3v10A3,3,0,0,1,47.01,30.0208Zm-30,4h10a3,3,0,0,1,3,3v10a3,3,0,0,1-3,3h-10a3,3,0,0,1-3-3v-10A3,3,0,0,1,17.01,34.0209Zm-3-17a3,3,0,0,1,3-3h10a3,3,0,0,1,3,3v10a3,3,0,0,1-3,3h-10a3,3,0,0,1-3-3Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol